import * as React from 'react';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { __ } from 'react-i18n';
import { IconImg } from '../../Defaults/Icon/IconImg';
import * as arrowSrc from '../../../../assets/zemplin/arrow-triangle-blue.svg';

interface Props {
  title: string;
  desc: string;
  categoryBannerUrl: string;
}

function CategoryHeader({ title, desc, categoryBannerUrl }: Props) {
  const [isShowingAll, setIsShowingAll] = React.useState(false);
  const descSize = 200;
  const shortCategoryDescr =
    desc.length > descSize ? desc.substr(0, descSize) + '...' : null;

  const toggleShowingAll = () => {
    setIsShowingAll(!isShowingAll);
  };

  return (
    <Wrapper>
      <Title>{title}</Title>
      {desc && desc !== '' && (
        <Desc shortCategoryDescr={shortCategoryDescr}>
          {!isShowingAll && shortCategoryDescr ? shortCategoryDescr : desc}
        </Desc>
      )}
      {shortCategoryDescr && (
        <ShowMoreWrapper onClick={toggleShowingAll}>
          {isShowingAll ? __('Skryť') : __('Zobraziť viac')}
          <IconImg
            cursor={'pointer'}
            width={8}
            height={4}
            marginLeft={9}
            rotate={isShowingAll ? 180 : 0}
            alt="arrow-icon"
            src={arrowSrc.toString()}
          />
        </ShowMoreWrapper>
      )}
      {categoryBannerUrl && categoryBannerUrl !== '' ? (
        <ImageWrapper>
          <img src={categoryBannerUrl} alt={title} />
        </ImageWrapper>
      ) : null}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  /* border-bottom: ${rem(1)} solid #e8e8e8; */

  ${({ theme }) => theme.mediab.s450`
    border-bottom: none;
  `}
`;

const ImageWrapper = styled(FlexCol)`
  border-radius: 8px;
  margin-bottom: ${rem(24)};
`;

const Title = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: ${rem(36)};
  line-height: ${rem(38)};
  margin-bottom: ${rem(24)};
  color: #003463;

  ${({ theme }) => theme.mediab.s450`
    font-weight: 500;
    font-size: ${rem(24)};
    line-height: ${rem(28)};
  `}
`;

const Desc = styled(TextP)<{ shortCategoryDescr: any }>`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: ${rem(24)};
  font-size: ${rem(16)};
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: ${({ shortCategoryDescr }) =>
    shortCategoryDescr ? rem(24) : rem(32)};
`;

const ShowMoreWrapper = styled(FlexRowCenterVertical)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.secondary};
  width: fit-content;
  cursor: pointer;
  margin-bottom: ${rem(32)};
`;

export { CategoryHeader as SanitasCategoryHeader };
